import script from "./AmazonWarningDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./AmazonWarningDialog.vue?vue&type=script&setup=true&lang=ts"

import "./AmazonWarningDialog.vue?vue&type=style&index=0&id=31c72306&lang=scss"
import "./AmazonWarningDialog.vue?vue&type=style&index=1&id=31c72306&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31c72306"]])

export default __exports__